import { FACILITY_QR_DISPLAY_FIELDS } from "lib/utils/facilityQr";

export default function FacilityQrMetadata({ metadata, t }) {
  return (
    <dl className="facilityQrMetadata">
      {FACILITY_QR_DISPLAY_FIELDS.map((key) => (
        <div key={key}>
          <dt>{t(`facilityQr.fields.${key}`)}</dt>
          <dd>{metadata?.[key] || t("facilityQr.unassigned")}</dd>
        </div>
      ))}
    </dl>
  );
}
